/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, TextField, Tooltip, withStyles } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { coreRed } from '../../themeprovider/ccmTheme/colorPalette';

const useStyles = makeStyles({
  input: {
    backgroundColor: '#FDF6CF',
    borderRadius: '4px 4px 0px 0px',
    width: '100%',
  },
  inputLabel: {
    paddingBottom: '10px',
    paddingTop: '5px',
    display: 'flex',
    alignItems: 'center',
  },
  boldText: {
    fontWeight: 'bold',
  },
  error: {
    paddingTop: '30px',
    fontSize: '14px',
    color: coreRed,
  },
  characterCount: {
    marginTop: '5px',
  },
  errorText: {
    color: coreRed,
  },
  radioLegend: {
    color: 'black',
    fontSize: '16px',
    paddingBottom: '10px',
    paddingTop: '20px',
  },
});

const FormTextInput = (props) => {
  const {
    fieldName,
    value,
    error,
    showErrorText,
    label,
    boldLabel,
    tooltip,
    tooltipText,
    maxCharacters,
    showCharacterCount,
    handleChange,
    multiLine,
    rows,
    textFieldInputProps,
    type,
    handleBlur,
    placeholder,
  } = props;

  const classes = useStyles();

  const CustomTooltip = withStyles({
    tooltip: {
      color: 'black',
      backgroundColor: '#FFFFFF',
      border: '1px solid #E2E2E2',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      borderRadius: '10px',
      fontSize: '14px',
      fontFamily: 'Open sans',
      padding: '10px',
    },
  })(Tooltip);

  return (
    <>
      {showErrorText ? (
        <div className={classes.error}>
          <span>{typeof error === 'string' ? error : '\u00A0'}</span>
        </div>
      ) : null}
      <label
        htmlFor={fieldName}
        className={`${classes.inputLabel} ${boldLabel ? classes.boldText : ''}`}
      >
        {label}
        &nbsp;
        {tooltip ? (
          <CustomTooltip
            placement="right-start"
            title={tooltipText}
            enterTouchDelay={100}
            leaveTouchDelay={3000}
          >
            <InfoOutlinedIcon
              htmlColor={error ? coreRed : 'black'}
              data-testid="tooltip"
            />
          </CustomTooltip>
        ) : null}
      </label>
      <TextField
        id={fieldName}
        name={fieldName}
        variant="standard"
        className={classes.input}
        onChange={handleChange}
        value={value}
        error={!!error}
        rows={rows}
        multiline={multiLine}
        inputProps={{ textFieldInputProps, maxLength: maxCharacters }}
        type={type}
        onBlur={handleBlur}
        placeholder={placeholder}
      />
      {showCharacterCount ? (
        <div
          className={`${classes.characterCount} ${
            value.length > maxCharacters ? classes.errorText : ''
          }`}
        >
          {`${maxCharacters - value.length} characters remaining`}
        </div>
      ) : null}
    </>
  );
};

export default FormTextInput;

FormTextInput.propTypes = {
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  showErrorText: PropTypes.bool,
  label: PropTypes.string.isRequired,
  boldLabel: PropTypes.bool,
  tooltip: PropTypes.bool,
  tooltipText: PropTypes.string,
  maxCharacters: PropTypes.number,
  showCharacterCount: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  multiLine: PropTypes.bool,
  rows: PropTypes.number,
  textFieldInputProps: PropTypes.object,
  type: PropTypes.string,
  handleBlur: PropTypes.func,
  placeholder: PropTypes.string,
};

FormTextInput.defaultProps = {
  showErrorText: false,
  tooltip: false,
  tooltipText: '',
  showCharacterCount: false,
  maxCharacters: 100,
  multiLine: false,
  rows: undefined,
  boldLabel: false,
  textFieldInputProps: undefined,
  type: 'text',
  handleBlur: undefined,
  placeholder: '',
};
